import Footer from './Footer'

export * from './Footer.types'
export default Footer
